module.exports = __webpack_public_path__ + "static/media/Document.a27c08d4.jpg";